<template>
    <FormSection title="Face Sheet Comments" :full-height="false" :application-id="application">
        <template #content>
            <section class="d-flex flex-column px-4 py-2">
                <div class="form-group col-12">
                    <p class="m-0 pb-1">Comments added here will be visible on the patient's face sheet.</p>
                    <CommentInput
                        input-name="referral-comments"
                        placeholder="Enter Comments"
                        :max-length="2000"
                        :show-template-typeahead="false"
                        :show-template-dropdown="true"
                        :application="application"
                        :result="patientDetails.demographics.faceSheetComments"
                        v-on:resultUpdatedAppended="resultUpdatedAppended"
                        v-on:resultUpdated="resultUpdated"
                        :class-list="commentInputClass"
                    />
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script src="./FacesheetComments.ts"></script>
